import {PropsWithChildren} from '../utilities/props';
import {Theme} from '../utilities/color';

export enum UiLineType {
  AdditionalInfo,
  BeforeWeekend,
  FasterOptions,
  BrandImage,
  MarketingMessage,
  TitleWithBrand,
  Title,
  TrackingIncluded,
  Destination,
  DestinationFullWidth,
  ConditionallyFree,
  ExpiryLine,
  ErrorLine,
  FullSize,
  MergedColumns,
  Generic,
}

export type LayoutProps = PropsWithChildren<{
  isHidden: boolean;
  isLoading: boolean;
  hasBrand?: boolean;
  theme: Theme;
  fontOverride?: boolean;
}>;
